const WhyAndFaqSection = () => {
  const benefits = [
    "Reduce hiring costs",
    "Scale teams faster",
    "Access niche technical skills",
    "Accelerate time-to-market",
    "Lower operational overhead",
  ];

  const faqs = [
    {
      question: "What is IT Staff Augmentation?",
      answer:
        "A flexible hiring model where businesses extend their team with external skilled developers to fill gaps or scale projects quickly.",
    },
    {
      question: "Why choose an IT staff augmentation company in USA?",
      answer:
        "We combine speed, quality, and transparency — helping you scale without hiring delays while maintaining full control.",
    },
    {
      question: "What industries benefit from managed IT support services?",
      answer:
        "Healthcare, finance, retail, SaaS, and logistics industries benefit significantly due to security, uptime, and compliance needs.",
    },
    {
      question: "What makes TekIT different from other IT staff augmentation firms?",
      answer:
        "TekIT combines rapid onboarding, SLA-backed support, continuous evaluation, and transparent communication to deliver consistent project success.",
    },
  ];

  return (
    <section className="bg-black text-white py-16 px-6 font-recoleta">
      <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-12">
        
        {/* 🔹 WHY SECTION */}
        <div>
          <h2 className="text-2xl lg:text-3xl font-bold text-cyan-400 mb-6">
            Why Businesses Choose Our Staffing Services
          </h2>

          <ul className="space-y-3 text-white/80 text-sm lg:text-base">
            {benefits.map((item, i) => (
              <li key={i} className="flex items-start gap-2">
                <span className="text-green-400">✔</span>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* 🔹 FAQ SECTION */}
        <div>
          <h2 className="text-2xl lg:text-3xl font-bold text-cyan-400 mb-6">
            Frequently Asked Questions
          </h2>

          <div className="space-y-4">
            {faqs.map((faq, i) => (
              <div
                key={i}
                className="border border-gray-700 rounded-xl p-4 bg-[#171717]"
              >
                <h4 className="font-semibold text-white text-sm lg:text-base mb-2">
                  {faq.question}
                </h4>
                <p className="text-white/70 text-xs lg:text-sm leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default WhyAndFaqSection;